import Index from '@/pages/operation/Index'
import List from '@/pages/operation/List'

export default {
  path: 'operation',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    }
  ]
}

